
export const marginX = v => {
  return {
    marginLeft: v,
    marginRight: v
  }
}


export const marginY = v => {
  return {
    marginTop: v,
    marginBottom: v
  }
}